<template>
  <div class="risk-analysis-dashboard">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1 class="text-h4 mb-6">Risk Analysis Dashboard</h1>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card class="mb-6">
            <v-card-title>Risk Overview</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="4">
                  <v-card outlined>
                    <v-card-text class="text-center">
                      <div class="text-h3 mb-2">{{ totalRisks }}</div>
                      <div class="text-subtitle-1">Total Risks</div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card outlined>
                    <v-card-text class="text-center">
                      <div class="text-h3 mb-2">{{ highRisksCount }}</div>
                      <div class="text-subtitle-1">High Impact Risks</div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card outlined>
                    <v-card-text class="text-center">
                      <div class="text-h3 mb-2">{{ riskCategories.length }}</div>
                      <div class="text-subtitle-1">Risk Categories</div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <risk-analysis-pie-charts :risk-data="risks" />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Risk List
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="risks"
              :search="search"
              :loading="loading"
              class="elevation-1"
            >
              <template #[`item.impact`]="{ item }">
                <v-chip
                  :color="getImpactColor(item.impact)"
                  text-color="white"
                  small
                >
                  {{ item.impact }}
                </v-chip>
              </template>
              <template #[`item.actions`]="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="editRisk(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  small
                  @click="deleteRisk(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import RiskAnalysisPieCharts from '@/components/RiskAnalysisPieCharts.vue';

export default defineComponent({
  name: 'RiskAnalysisDashboard',
  components: {
    RiskAnalysisPieCharts
  },
  data() {
    return {
      search: '',
      headers: [
        { text: 'Category', value: 'category' },
        { text: 'Description', value: 'description' },
        { text: 'Impact', value: 'impact' },
        { text: 'Mitigation', value: 'mitigation' },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    ...mapState('riskAnalysis', ['risks', 'loading', 'error']),
    ...mapGetters('riskAnalysis', ['getRiskCategories', 'getRisksByImpact']),
    totalRisks() {
      return this.risks.length;
    },
    highRisksCount() {
      return this.getRisksByImpact('High').length;
    },
    riskCategories() {
      return this.getRiskCategories;
    }
  },
  methods: {
    ...mapActions('riskAnalysis', ['fetchRisks', 'deleteRisk']),
    getImpactColor(impact) {
      const colors = {
        High: 'error',
        Medium: 'warning',
        Low: 'success'
      };
      return colors[impact] || 'grey';
    },
    editRisk(risk) {
      // TODO: Implement edit functionality
      console.log('Edit risk:', risk);
    },
    async confirmDelete(risk) {
      try {
        await this.deleteRisk(risk.id);
        // Show success message
      } catch (error) {
        // Show error message
        console.error('Error deleting risk:', error);
      }
    }
  },
  mounted() {
    this.fetchRisks();
  }
});
</script>

<style scoped>
.risk-analysis-dashboard {
  padding: 20px 0;
}
</style> 